require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./news-ironside-are-kicking-goals-at-yarrabend.json") })
        }
      }, "path---news-ironside-are-kicking-goals-at-yarrabend");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---news-ironside-are-kicking-goals-at-yarrabend!./.cache/json/news-ironside-are-kicking-goals-at-yarrabend.json
// module id = 823
// module chunks = 231608221292675